import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { 
  FileText, 
  ArrowLeft,
  Users,
  Shield,
  CreditCard,
  AlertTriangle,
  Scale,
  CheckCircle,
  XCircle,
  Clock,
  Mail,
  Phone,
  Building2,
  Gavel
} from 'lucide-react';

const KullanimKosullari = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-gradient-to-br from-[#006D77] via-[#0A9396] to-[#006D77] overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
        
        <div className="max-w-4xl mx-auto px-4 relative z-10">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-5 py-2.5 mb-6">
              <Gavel className="w-5 h-5 text-white" />
              <span className="text-white font-semibold">Yasal Metin</span>
            </div>
            
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Kullanım Koşulları
              <span className="block text-[#F6AD55] mt-2">ve Kullanıcı Sözleşmesi</span>
            </h1>
            
            <p className="text-white/80 text-lg max-w-2xl mx-auto">
              Son güncelleme: Ocak 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-20">
        <div className="max-w-4xl mx-auto px-4">
          {/* Back Button */}
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="mb-8 border-[#006D77] text-[#006D77] hover:bg-[#006D77] hover:text-white"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Geri Dön
          </Button>

          {/* Terms Content */}
          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
            
            {/* Section 1: Giriş */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">1. GİRİŞ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>1.1.</strong> İşbu kullanıcı sözleşmesi ve Web Sitesi'nde yer alan diğer kurallar, 
                  HizmetGeliyo tarafından sunulan hizmetlere ilişkin şart ve koşulları ve Web Sitesi'nin 
                  kullanılmasına ilişkin kuralları düzenlemektedir.
                </p>
                
                <div className="bg-[#006D77]/5 rounded-xl p-5 border border-[#006D77]/20">
                  <p>
                    <strong>1.2.</strong> Kullanıcı'nın, Web Sitesi üzerinden Hizmet Talebi veya Usta Profili 
                    oluştururken işbu Sözleşmeyi onayladığı veya Web Sitesi'nden yararlanmaya başladığı andan 
                    itibaren işbu Sözleşmeye uymayı taahhüt ettiği kabul edilir.
                  </p>
                </div>

                <p>
                  <strong>1.3.</strong> HizmetGeliyo, aracılık hizmetlerinin sürekliliğini sağlama, ileride 
                  doğacak teknik zaruretler veya mevzuata uyum sağlanması amacıyla Sözleşmeyi Kullanıcılar 
                  aleyhine olmamak kaydıyla tek taraflı olarak değiştirme ya da tadil etme hakkına sahiptir.
                </p>

                <p>
                  <strong>1.4.</strong> Koşulların sizin için uygun olmaması halinde lütfen Web Sitesi'ni 
                  ve sunulan hizmetleri kullanmayınız.
                </p>
              </div>
            </div>

            {/* Section 2: Tanımlar */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">2. TANIMLAR</h2>
              </div>
              
              <div className="space-y-3 text-gray-600 leading-relaxed">
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"HizmetGeliyo"</strong>: hizmetgeliyo.com internet sitesini 
                  ve mobil uygulamalarını işleten şirketi ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Web Sitesi"</strong>: hizmetgeliyo.com internet sitesini 
                  ve iOS/Android tabanlı mobil uygulamaları ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Kullanıcı"</strong>: Herhangi bir sebeple Web Sitesi'ni 
                  kullanan kişileri ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Hizmet Alan"</strong>: Web Sitesi üzerinden hizmet talep 
                  eden gerçek veya tüzel kişi Kullanıcı'yı ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Hizmet Veren (Usta)"</strong>: Hizmet sağlamak üzere Web 
                  Sitesi üzerinden kayıt olan ve onaylanan profesyonel hizmet sağlayıcıyı ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Hizmet Talebi"</strong>: Hizmet Alan tarafından, bir veya 
                  daha fazla Usta'dan teklif almak amacıyla Web Sitesi üzerinde oluşturulan talebi ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Teklif"</strong>: Usta'nın, Hizmet Alan'ın gönderdiği 
                  Hizmet Talebi'ne yanıt olarak gönderdiği fiyat ve süre teklifini ifade eder.
                </div>
                <div className="bg-white rounded-lg p-4 border border-gray-200">
                  <strong className="text-gray-900">"Anlaşmaya Varılmış İş"</strong>: Usta tarafından gönderilen 
                  Teklif'in Hizmet Alan tarafından kabul edilmesi sonucu oluşan anlaşmayı ifade eder.
                </div>
              </div>
            </div>

            {/* Section 3: Sunulan Hizmetler */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                  <CheckCircle className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">3. HİZMETGELİYO TARAFINDAN SUNULAN HİZMETLER</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>3.1.</strong> HizmetGeliyo, Hizmet Veren ve Hizmet Alan'ın içeriklerini kendileri 
                  oluşturdukları hizmet talebi bilgilerinin, kendisine bildirilen içeriğe uygun olarak ve 
                  işbu Sözleşme hükümleri çerçevesinde, Web Sitesi'nde yer almasını sağlar.
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                    <p className="text-amber-800">
                      <strong>3.2.</strong> HizmetGeliyo yalnızca bir platformdur, Web Sitesi'nde yer alan 
                      hizmetlerin sahibi veya sağlayıcısı değildir. HizmetGeliyo aracı hizmet sağlayıcıdır 
                      ve hizmet sunduğu elektronik ortamı kullanan gerçek ve tüzel kişiler tarafından 
                      sağlanan içeriği kontrol etmek, bu içerik ve içeriğe konu mal veya hizmetle ilgili 
                      hukuka aykırı bir faaliyetin ya da durumun söz konusu olup olmadığını araştırmakla 
                      yükümlü değildir.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 4: Üyelik Sistemi */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-purple-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-violet-600 rounded-xl flex items-center justify-center">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">4. ÜYELİK SİSTEMİ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>4.1.</strong> Web Sitesi'ne üyelik ücretsizdir. Üyeler, tek bir hesap üzerinden 
                  aynı anda birden fazla Hizmet Talebi gönderebilirler.
                </p>

                <p>
                  <strong>4.2.</strong> Şifre'nin belirlenmesi ve korunması üyenin kendi sorumluluğundadır. 
                  Kullanıcı adı ve şifresi paylaşılmamalı ve özenle korunmalıdır.
                </p>

                <p>
                  <strong>4.3.</strong> Üye, hesabının kendi kusuru nedeniyle başka kişiler tarafından kötü 
                  niyetle kullanılmasından doğrudan sorumludur.
                </p>

                <p>
                  <strong>4.4.</strong> Üye hesabı oluştururken Web Sitesi'ne beyan edilen isim, adres, 
                  telefon, e-posta gibi her türlü bilgi, güncel, doğru ve eksiksiz olmalıdır.
                </p>

                <p>
                  <strong>4.5.</strong> Üyeliğe ilişkin kullanım hakları, kullanıcı adı ve şifresi 
                  başkalarına devredilemez.
                </p>
              </div>
            </div>

            {/* Section 5: Hizmet Talebi */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">5. HİZMET TALEBİ OLUŞTURULMASI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>5.1.</strong> En az 18 yaşında olan ve temyiz kudretini haiz herhangi bir 
                  Kullanıcı, işbu Sözleşme koşulları uyarınca kayıt formunda talep edilen bilgileri 
                  doğru ve eksiksiz olarak doldurarak bir Hizmet Talebi oluşturabilir.
                </p>

                <p>
                  <strong>5.2.</strong> Geçerli bir Hizmet Talebi oluşturmak için hizmete ilişkin gerekli 
                  bilgilerin (talep edilen işin niteliği, özelliği, kalitesi, ölçüleri, ifa ve teslim yeri 
                  ve işin süresi vb.) eksiksiz, doğru ve açık olarak verilmesi gerekir.
                </p>

                <p>
                  <strong>5.3.</strong> HizmetGeliyo, Hizmet Talebini denetiminden geçirdikten sonra, 
                  uygun olması halinde yayımlar. Ancak Hizmet Talebi'nin içeriğine ilişkin tüm 
                  sorumluluk Hizmet Alan'a aittir.
                </p>

                <div className="bg-red-50 border border-red-200 rounded-xl p-5">
                  <p className="text-red-800">
                    <strong>5.4.</strong> Etik ve ahlaki değerlere uygun olmayan talep içerikleri 
                    oluşturulmamalı, bu tip içerikli taleplere teklif verilmemelidir. Bu tür talepleri 
                    oluşturma ya da bu tür taleplere teklif verme sebebiyle doğacak tüm sorumluluk 
                    ilgili Kullanıcı'ya aittir.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 6: Ödeme */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center">
                  <CreditCard className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">6. ÖDEME</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>6.1.</strong> Hizmet Alanlar kabul ettikleri Teklif'e ilişkin hizmet bedelini, 
                  hizmetin ifası sonrasında Usta'ya doğrudan ödeme yaparlar.
                </p>

                <p>
                  <strong>6.2.</strong> Hizmet Alanlar, ödedikleri bedelin faturası, satış fişi veya 
                  irsaliyesini Usta'dan talep etmelidir.
                </p>

                <p>
                  <strong>6.3.</strong> HizmetGeliyo, Online Ödeme Sistemi kullandığında hizmet karşılığı 
                  fiş/fatura veya düzenlenmesi gerekli diğer belgeler, ilgili mevzuat gereği düzenleme 
                  yükümlülükleri bulunuyorsa ilgili Usta tarafından düzenlenir.
                </p>

                <div className="bg-green-50 border border-green-200 rounded-xl p-5">
                  <p className="text-green-800">
                    <strong>6.4.</strong> Online Ödeme Sistemi ile ödeme yapılan durumlarda, kartın hamili 
                    haricinde bir başkası tarafından hukuka aykırı şekilde kullanılması halinde 5464 sayılı 
                    Banka Kartları ve Kredi Kartları Kanunu hükümlerine göre işlem yapılır.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 7: Hizmet Sorumluluğu */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">7. HİZMET SORUMLULUĞU VE GARANTİ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>7.1.</strong> HizmetGeliyo'nun Hizmet Alan ile Usta arasındaki teklif, icap, 
                  kabul, sözleşme ve ödeme aşamalarında herhangi bir sorumluluğu bulunmamaktadır.
                </p>

                <p>
                  <strong>7.2.</strong> Web Sitesi aracılığı ile Ustalardan alınacak hizmetlere ilişkin 
                  her türlü sorumluluk Ustalara aittir. HizmetGeliyo'nun hiçbir sorumluluğu bulunmaz.
                </p>

                <p>
                  <strong>7.3.</strong> HizmetGeliyo, Usta'yı veya hizmetlerini tasdik veya tavsiye etmez, 
                  çalışma performansını ya da verilen hizmetlerin sonucu veya kalitesini garanti etmez.
                </p>

                <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
                  <div className="flex items-start gap-3">
                    <Shield className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-blue-800 mb-2">HizmetGeliyo Garantisi</p>
                      <p className="text-blue-700 text-sm">
                        <strong>7.4.</strong> HizmetGeliyo, hizmet kalitesini ve Hizmet Alan memnuniyetini 
                        sağlamak amacıyla Hizmet Alanlara Web Sitesi üzerinden Anlaşmaya Varılmış İş'lerde 
                        HizmetGeliyo Garantisi sunmaktadır. Garanti koşulları için 
                        <a href="/garanti-sartlari" className="underline ml-1">Garanti Şartları</a> sayfasını 
                        ziyaret edebilirsiniz.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 8: Hizmet Alan Yükümlülükleri */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-rose-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-pink-600 rounded-xl flex items-center justify-center">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">8. HİZMET ALAN'IN YÜKÜMLÜLÜKLERİ</h2>
              </div>
              
              <div className="space-y-3 text-gray-600 leading-relaxed">
                {[
                  'İşbu Sözleşme koşullarına uymaması nedeniyle doğabilecek her türlü idari, hukuki ve cezai sorumluluk bizzat Hizmet Alan\'a aittir.',
                  'Hizmet Alan, Hizmet Talebi için yalnız bir Teklifi kabul edebilir. Teklifin kabul edilmesi, Hizmet verildiği takdirde Usta\'ya ödeme yapmak için yasal olarak bağlayıcı bir anlaşma yapıldığı anlamına gelir.',
                  'Hizmet Alan, Web Sitesi aracılığı ile oluşturulan bir Hizmet Talebi\'ne ilişkin olarak HizmetGeliyo\'nun bilgisi dahilinde olmaksızın, HizmetGeliyo\'yu dışarıda bırakmak amacıyla Usta ile iletişime geçmeyecektir.',
                  'Hizmet Alan, Usta ile yaptığı sözleşmede, HizmetGeliyo\'nun hiçbir şekilde sözleşmenin tarafı olmadığını ve sorumluluğu bulunmadığını kabul eder.',
                  'Hizmet Alan, hizmete ilişkin olarak kendisine düşen tüm vergilerden sorumludur.'
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3 bg-white rounded-lg p-4 border border-gray-200">
                    <span className="w-6 h-6 bg-rose-100 text-rose-600 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                      {idx + 1}
                    </span>
                    <span className="text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Section 9: Usta Yükümlülükleri */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">9. USTA'NIN YÜKÜMLÜLÜKLERİ</h2>
              </div>
              
              <div className="space-y-3 text-gray-600 leading-relaxed">
                {[
                  'İşbu Sözleşme koşullarına ve Hizmet Alan\'a karşı üstlendiği ifa yükümlülüklerine uymaması nedeniyle doğabilecek her türlü idari, hukuki ve cezai sorumluluk bizzat Usta\'ya aittir.',
                  'Usta\'nın Hizmet Talebi için verdiği teklif Hizmet Alan tarafından kabul edildiğinde, Hizmet\'in belirtilen zamanda ve yerde yapılacağına dair yasal anlaşma yapıldığı anlamına gelir.',
                  'Usta, Web Sitesi aracılığı ile oluşturulan bir Hizmet Talebi\'ne ilişkin olarak HizmetGeliyo\'nun bilgisi dahilinde olmaksızın, HizmetGeliyo\'yu dışarıda bırakmak amacıyla Hizmet Alan ile ayrıca bir iletişime geçmeyecektir.',
                  'Usta, Hizmet Alan ile yaptığı sözleşmede, HizmetGeliyo\'nun hiçbir şekilde sözleşmenin tarafı olmadığını kabul eder.',
                  'Usta\'nın kayıtlı olduğu vergi dairesine bildireceği kazanç beyanları, kendisinin yasal sorumluluğunda ve yükümlülüğündedir.',
                  'Usta, işin ifası sırasında veya işin ifası için gerekli iş güvenliği ve iş sağlığına ilişkin bütün tedbirleri alacağını kabul eder.'
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3 bg-white rounded-lg p-4 border border-gray-200">
                    <span className="w-6 h-6 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold">
                      {idx + 1}
                    </span>
                    <span className="text-sm">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Section 10: Yasaklı İçerikler */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-red-50/50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-rose-600 rounded-xl flex items-center justify-center">
                  <XCircle className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">10. YASAKLI İÇERİKLER VE DAVRANIŞLAR</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  HizmetGeliyo, Web Sitesi üzerinde yasadışı veya yasak olacak türden içeriği kaldırma ve 
                  söz konusu ihlalcilerin üyeliğini sonlandırma hakkını saklı tutar. Bu hüküm aşağıdaki 
                  türden içeriği kapsar:
                </p>

                <div className="grid md:grid-cols-2 gap-3">
                  {[
                    'Irkçılık veya nefret söylemi içeren',
                    'Taciz eden veya tacizi savunan',
                    'Yanlış veya yanıltıcı bilgi içeren',
                    'İllegal faaliyetleri teşvik eden',
                    'Hakaret, tehdit veya iftira içeren',
                    'Müstehcen veya pornografik içerik',
                    'Telif haklarını ihlal eden',
                    'Virüs veya zararlı yazılım içeren',
                    'Spam veya istenmeyen reklam',
                    'Haksız rekabet oluşturan'
                  ].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2 bg-red-50 rounded-lg p-3 border border-red-200">
                      <XCircle className="w-4 h-4 text-red-500 flex-shrink-0" />
                      <span className="text-red-700 text-sm">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Section 11: Fikri Mülkiyet */}
            <div className="p-8 border-b border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center">
                  <Shield className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">11. FİKRİ MÜLKİYET HAKLARI</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>11.1.</strong> Web Sitesi'nde sunulan görsel ve yazılı içerik, kişisel kullanım 
                  içindir. HizmetGeliyo, Web Sitesi içeriğinde yer alan bütün alan adı, logo, grafik, ses, 
                  ikon, tasarım, metin, imge, html kodu, diğer kodlar dahil tüm materyallerin fikri ve 
                  sınai mülkiyet haklarının sahibi veya lisans sahibidir ve yasal koruma altındadır.
                </p>

                <p>
                  <strong>11.2.</strong> Bu sayfaların tasarımında ve veri tabanı oluşturulmasında kullanılan 
                  yazılımın hakkı HizmetGeliyo'ya aittir. Bahsi geçen yazılımın kopyalanması veya kullanılması 
                  kesinlikle yasaktır.
                </p>
              </div>
            </div>

            {/* Section 12: Uyuşmazlık */}
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-transparent">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-gray-500 to-slate-600 rounded-xl flex items-center justify-center">
                  <Scale className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">12. UYUŞMAZLIKLARIN ÇÖZÜMÜ</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>12.1.</strong> İşbu Sözleşme Türkiye Cumhuriyeti kanunlarına tabidir.
                </p>

                <p>
                  <strong>12.2.</strong> Taraflar, işbu Sözleşme'nin tatbik ve tefsirinden doğacak her 
                  türlü uyuşmazlıkları önce kendi aralarında sulhen halletmeye gayret ederler.
                </p>

                <div className="bg-gray-100 border border-gray-200 rounded-xl p-5">
                  <p>
                    <strong>12.3.</strong> Sulhen halledilemeyen uyuşmazlıkların çözümü için <strong>Ankara 
                    Mahkeme ve İcra Müdürlükleri</strong>'nin münhasıran yetkili olduğunu taraflar kabul 
                    ve beyan ederler.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 13: Yürürlük */}
            <div className="p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-xl flex items-center justify-center">
                  <Clock className="w-6 h-6 text-white" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">13. YÜRÜRLÜK</h2>
              </div>
              
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>13.1.</strong> Bu Sözleşme Web Sitesi kullanılmaya devam edildiği ve Kullanıcılara 
                  HizmetGeliyo tarafından yeni bir sözleşme sunulmadığı sürece yürürlükte kalacaktır.
                </p>

                <p>
                  <strong>13.2.</strong> HizmetGeliyo sisteminde kayıtlı kullanıcı bilgileri, teklifleri, 
                  yorum/değerlendirmeleri vb. en az üç (3) yıl boyunca saklanır.
                </p>

                <p>
                  <strong>13.3.</strong> Taraflar bu Sözleşme'den doğabilecek uyuşmazlıklarda HizmetGeliyo'nun 
                  ticari defter ve kayıtları ile sistemlerinde saklanan verileri her türlü uyuşmazlıkta 
                  6100 Sayılı HMK'nın 193. Maddesi gereği kesin delil kabul edeceğini beyan, kabul ve 
                  taahhüt ederler.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Box */}
          <div className="mt-12 bg-gradient-to-br from-[#006D77] to-[#0A9396] rounded-3xl p-8 text-white">
            <div className="text-center mb-6">
              <Building2 className="w-12 h-12 mx-auto mb-4 opacity-80" />
              <h3 className="text-2xl font-bold mb-2">İletişim</h3>
              <p className="text-white/80">
                Kullanım koşulları hakkında sorularınız için bizimle iletişime geçin.
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-4">
              <a 
                href="mailto:destek@hizmetgeliyo.com"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span className="font-semibold">destek@hizmetgeliyo.com</span>
              </a>
              <a 
                href="tel:08502427808"
                className="flex items-center justify-center gap-3 bg-white/20 hover:bg-white/30 rounded-xl p-4 transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span className="font-semibold">0850 242 78 08</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default KullanimKosullari;
